module.exports = __webpack_public_path__ + "img/natalya.1f5fd0b1.png";